import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { WHATSAPP_URL } from '../constants/contact';

function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      title="Contactanos por WhatsApp"
      aria-label="Contactanos por WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}

export default WhatsAppButton;
